// officehome code has extra escape characters on app definitions, leading to strings not objects
export var fixDoublyEscapedData = function (data) {
    return data.map(function (_) {
        return (typeof _ === 'string' ? JSON.parse(_) : _);
    });
};
//# sourceMappingURL=fixDoublyEscapedData.js.map